import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpClient, HttpEventType } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-flow-rating-short",
  templateUrl: "./flow-rating-short.component.html",
  styleUrls: ["./flow-rating-short.component.scss"],
})
export class FlowRatingShortComponent implements OnInit {
  flowData: any;
  userData: any;
  rating: number = 0;
  reviewText: string = "";
  selectedFile: File | null = null;
  mediaUrl: string = "";
  mediaThumbnailUrl: string = "";
  isVideo: boolean = false;
  isUploading: boolean = false;
  uploadProgress: number = 0;
  showPreview: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<FlowRatingShortComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private flowServiceService: FlowServiceService,
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private mediaUploadService: MediaUploadService
  ) {
    this.flowData = data.flowData;
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
  }

  ngOnInit() {
    if (!this.userData) {
      this.dialogRef.close();
      this.router.navigate(["/registration"]);
    }
  }

  setRating(value: number) {
    this.rating = value;
  }

  async onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.selectedFile = file;
    this.isUploading = true;
    this.uploadProgress = 0;

    const imageExtensions = [
      "jpeg", "jpg", "png", "gif", "jfif", "tiff", "tif", "pdf",
      "bmp", "webp", "svg", "heic", "heif", "raw", "arw", "cr2",
      "nef", "orf", "rw2", "dng", "psd", "ico", "exif", "pjpeg"
    ];
    const videoExtensions = [
      "mp4", "mov", "wmv", "flv", "avchd", "webm", "mkv", "vob",
      "ogv", "gifv", "m4p", "m4v", "3gp", "3g2", "avi", "mpg", "mpeg"
    ];

    const fileName = file.name.toLowerCase();
    const isImage = imageExtensions.some((ext) => fileName.includes(ext));
    const isVideo = videoExtensions.some((ext) => fileName.includes(ext));

    if (!isImage && !isVideo) {
      this.toastr.error("Please select an image or video file");
      this.selectedFile = null;
      this.isUploading = false;
      return;
    }

    this.isVideo = isVideo;

    let fileToUpload = file;
    if (isVideo) {
      try {
        fileToUpload = await this.mediaUploadService.prepareFileForUpload(file);
        this.selectedFile = fileToUpload;
      } catch (error: any) {
        this.isUploading = false;
        this.selectedFile = null;
        this.toastr.error(error?.message || this.mediaUploadService.uploadTooLargeMessage());
        return;
      }
    }

    const formData = new FormData();
    formData.append("fileData", fileToUpload);

    const uploadUrl = isImage
      ? environment.apiBaseUrl + environment.uploadImageUrl
      : environment.apiBaseUrl + environment.uploadVideoUrl;

    this.http
      .post(uploadUrl, formData, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe(
        (event: any) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.uploadProgress = Math.round(
                  (event.loaded / event.total) * 100
                );
              }
              break;

            case HttpEventType.Response:
              const mediaUploadStatus = event.body as any;
              this.isUploading = false;

              if (mediaUploadStatus != null && mediaUploadStatus.status) {
                if (isImage) {
                  this.mediaUrl =
                    environment.imageStorageBaseUrl +
                    mediaUploadStatus.fileName;
                  this.mediaThumbnailUrl = this.mediaUrl;
                  this.showPreview = true;
                } else if (isVideo) {
                  this.mediaUrl =
                    environment.videoStorageBaseUrl +
                    mediaUploadStatus.fileName;
                  // For videos, thumbnail would be generated separately or use poster
                  this.mediaThumbnailUrl = this.mediaUrl;
                  this.showPreview = true;
                }
                this.toastr.success("Media uploaded successfully");
              } else {
                this.toastr.error(mediaUploadStatus?.message || "Upload failed");
                this.selectedFile = null;
              }
              break;
          }
        },
        (error) => {
          this.isUploading = false;
          this.toastr.error(this.mediaUploadService.uploadTooLargeMessage());
          this.selectedFile = null;
        }
      );
  }

  removeMedia() {
    this.selectedFile = null;
    this.mediaUrl = "";
    this.mediaThumbnailUrl = "";
    this.showPreview = false;
    this.isVideo = false;
  }

  submit() {
    if (this.rating === 0) {
      this.toastr.warning("Please provide a rating");
      return;
    }

    if (!this.mediaUrl && !this.reviewText) {
      this.toastr.warning("Please add a review or upload media");
      return;
    }

    const flowShortModel = {
      FlowRowKey: this.flowData.rowKey,
      Rating: this.rating,
      MediaUrl: this.mediaUrl || null,
      MediaThumbnailUrl: this.mediaThumbnailUrl || null,
      IsVideo: this.isVideo,
      ReviewText: this.reviewText || null,
      CreatedByUserEmail: this.userData.emailAddress,
    };

    this.flowServiceService.createFlowShort(flowShortModel).subscribe(
      (response) => {
        this.toastr.success("Thank you for your rating and review!");
        this.dialogRef.close(true);
      },
      (error) => {
        this.toastr.error("Error submitting rating. Please try again.");
        console.error(error);
      }
    );
  }

  skip() {
    this.dialogRef.close(false);
  }

  close() {
    this.dialogRef.close(false);
  }
}


